export default __webpack_public_path__ + "static/icon-bru-logo-3275ed1448ba7c1881459db39c256dac.svg";